import PageHero from "../components/PageHero";
import CtaBanner from "../components/CtaBanner";
import QuoteForm from "../components/QuoteForm";
import { Reveal } from "../components/Reveal";
import { galleryImages } from "../data/site";

const features = [
  "Custom patios & paver installation",
  "Walkways & garden paths",
  "Retaining walls & stonework",
  "Decks & fencing",
  "Fire pits & seating areas",
  "Drainage & grading solutions",
];

const Hardscaping = () => (
  <div data-testid="hardscaping-page">
    <PageHero
      overline="Hardscaping"
      title="Our landscape work: built by inspiration."
      subtitle="Custom patios, walkways, retaining walls, decks and fences — designed and installed to last."
      image={galleryImages[0]}
    />

    <section className="py-24 md:py-32 bg-bone">
      <div className="container-fl grid md:grid-cols-12 gap-12 md:gap-20 items-start">
        <Reveal className="md:col-span-6">
          <p className="overline mb-5">Craftsmanship</p>
          <h2 className="text-4xl md:text-5xl leading-tight mb-6">Structure and beauty, built into your landscape.</h2>
          <p className="text-lg text-moss leading-relaxed">
            Our hardscaping brings permanence and character to your outdoor space. From the first design to the final stone, our team builds functional, striking features engineered for the Alberta climate and made to enjoy for decades.
          </p>
        </Reveal>
        <Reveal delay={0.15} className="md:col-span-6">
          <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-5">
            {features.map((f) => (
              <li key={f} className="flex items-start gap-3 text-ink border-b border-line pb-4">
                <span className="text-clay mt-1">—</span>
                <span className="font-medium">{f}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>

    <section className="pb-24 md:pb-32 bg-bone">
      <div className="container-fl">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {galleryImages.map((img, i) => (
            <Reveal key={i} delay={(i % 3) * 0.06}>
              <div className={`overflow-hidden group ${i % 5 === 0 ? "row-span-2 aspect-[3/4]" : "aspect-square"}`}>
                <img src={img} alt={`Hardscaping project ${i + 1}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <section className="py-24 md:py-28 bg-sand">
      <div className="container-fl grid md:grid-cols-12 gap-14">
        <Reveal className="md:col-span-5">
          <p className="overline mb-5">For All Hardscaping Quotes</p>
          <h2 className="text-4xl md:text-5xl leading-tight">Let's design your space.</h2>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-7 bg-white p-8 md:p-12 border border-line">
          <QuoteForm defaultService="Hardscaping" />
        </Reveal>
      </div>
    </section>

    <CtaBanner />
  </div>
);

export default Hardscaping;
